import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import InquiryModal from '../components/InquiryModal'

export default function ConceptPage() {
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    document.title = 'Konceptet - SKI & CO TRAVEL ApS'
  }, [])

  const konceptCards = [
    {
      titel: 'Produktseminar',
      beskrivelse: 'Saml salgsteamet om lanceringen i rammer, der matcher ambitionerne.',
      icon: 'fa-box-open',
    },
    {
      titel: 'Salgsmøder',
      beskrivelse: 'Få mere ud af kvartalsmødet med en dagsorden, der rykker udenfor kontoret.',
      icon: 'fa-chart-line',
    },
    {
      titel: 'Value-creation',
      beskrivelse: 'Skab rum til de strategiske samtaler, der sjældent opstår ved skrivebordet.',
      icon: 'fa-lightbulb',
    },
    {
      titel: 'Workshops',
      beskrivelse: 'Kombiner fagligt indhold med aktiviteter, der bygger sammenhold.',
      icon: 'fa-people-group',
    },
    {
      titel: 'Netværksmøder',
      beskrivelse: 'Bring kunder og kolleger sammen om en oplevelse, de husker meget lang tid.',
      icon: 'fa-handshake',
    },
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-16">
      {/* Header */}
      <div className="space-y-4 max-w-3xl">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
          KONCEPTET
        </span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-4xl text-white">
          Mere end en skitur
        </h1>
        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          Hvert år afholdes der tusindvis af møder rundt om i landet — de færreste huskes i ret lang tid. Et fælles arrangement i naturskønne omgivelser gør. Det er derfor, vi skræddersyer hvert arrangement, så det matcher formålet.
        </p>
      </div>

      {/* Grid of Concept Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {konceptCards.map((card, idx) => (
          <div
            key={idx}
            className="bg-slate-900 border border-slate-800 hover:border-cyan-500/50 rounded-3xl p-8 space-y-4 shadow-xl transition-all group"
          >
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 flex items-center justify-center text-2xl group-hover:bg-cyan-500 group-hover:text-slate-950 transition-colors">
              <i className={`fa-solid ${card.icon}`} aria-hidden="true" />
            </div>
            <h2 className="font-heading font-bold text-xl text-white group-hover:text-cyan-300 transition-colors">
              {card.titel}
            </h2>
            <p className="text-slate-300 text-sm leading-relaxed">
              {card.beskrivelse}
            </p>
          </div>
        ))}

        {/* Highlight Card */}
        <div className="bg-gradient-to-br from-cyan-950/60 to-slate-900 border border-cyan-500/30 rounded-3xl p-8 flex flex-col justify-between space-y-6 shadow-2xl">
          <div className="space-y-3">
            <span className="text-xs font-bold uppercase tracking-wider text-cyan-400">
              Alt i én løsning
            </span>
            <h2 className="font-heading font-bold text-xl text-white">
              Sømløs gennemførelse
            </h2>
            <p className="text-slate-300 text-sm leading-relaxed">
              Kort sagt: vi arrangerer alt fra transport, indkvartering og mødefaciliteter til foredragsholdere og gourmetoplevelser — jeres garanti for et arrangement, der huskes længe.
            </p>
          </div>

          <button
            onClick={() => setModalOpen(true)}
            className="w-full py-3.5 rounded-xl bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold text-sm transition-colors text-center shadow-lg shadow-cyan-400/20"
          >
            Få et skræddersyet tilbud
          </button>
        </div>
      </div>

      {/* Details Section */}
      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 sm:p-12 space-y-8">
        <div className="max-w-3xl space-y-4">
          <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white">
            Skræddersyet til jeres virksomheds behov
          </h2>
          <p className="text-slate-300 text-base leading-relaxed">
            Hvad enten I ønsker fokus på intensive workshops, uformelle netværksstunder i en hyggelig bjerghytte, eller gourmetmiddage kombineret med fantastisk skiløb, tilpasser vi alle detaljer til jeres ønsker og budget.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-6 border-t border-slate-800">
          <div className="space-y-2">
            <div className="text-cyan-400 font-bold text-lg flex items-center gap-2">
              <i className="fa-solid fa-hotel" aria-hidden="true" />
              <span>Indkvartering</span>
            </div>
            <p className="text-xs text-slate-400">
              Fra 5-stjernede luksushoteller til eksklusive lejligheder.
            </p>
          </div>

          <div className="space-y-2">
            <div className="text-cyan-400 font-bold text-lg flex items-center gap-2">
              <i className="fa-solid fa-plane-departure" aria-hidden="true" />
              <span>Transport</span>
            </div>
            <p className="text-xs text-slate-400">
              Fleksibel transport med fly, bus eller kør-selv efter ønske.
            </p>
          </div>

          <div className="space-y-2">
            <div className="text-cyan-400 font-bold text-lg flex items-center gap-2">
              <i className="fa-solid fa-microphone font-bold" aria-hidden="true" />
              <span>Fagligt indhold</span>
            </div>
            <p className="text-xs text-slate-400">
              Mødefaciliteter, salgscoaches, foredragsholdere og aktiviteter.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-4 pt-4">
          <Link
            to="/processen"
            className="px-6 py-3 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-sm transition-colors"
          >
            Se vores proces &rarr;
          </Link>
          <Link
            to="/kontakt"
            className="px-6 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm transition-colors border border-slate-700"
          >
            Kontakt os direkte
          </Link>
        </div>
      </div>

      <InquiryModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  )
}
